import React, { Component, Fragment } from "react";
import InfoElement from "./InfoElement/InfoElement";

import "./UserInfo.css";

class UserInfo extends Component {
    constructor(props) {
        super(props);

        this.on_edit = this.on_edit.bind(this);
        this.save_changes = this.save_changes.bind(this);
        this.select_input = this.select_input.bind(this);
    }

    componentDidMount() {
        this.props.connection &&
            this.props.connection
                .get_cities()
                .then((res) => {
                    this.setState({
                        cities: res.data,
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        this.componentDidUpdate();
    }

    componentDidUpdate() {
        let { costumer, connection, toast } = this.props;
        if (!costumer) {
            return;
        }
        if (
            !Object.keys(costumer).every((key) => {
                if (!this.state.costumer) return false;
                return this.state.costumer[key] == costumer[key];
            })
        ) {
            this.setState({ costumer });

            if (!costumer.address || !costumer.zip) {
                connection
                    .get_shipping_info()
                    .then((res) => {
                        costumer.name = res.data.name;
                        costumer.province = res.data.province;
                        costumer.city = res.data.city;
                        costumer.mobile = res.data.mobile;
                        costumer.address = res.data.address;
                        costumer.zip = res.data.zip;
                        this.setState({ costumer });
                    })
                    .catch((err) => {
                        toast(
                            "خطا در دریافت اطلاعات",
                            "اطلاعات آدرس دریافت نشد",
                            " danger"
                        );
                    });
            }
        }
    }

    on_edit(key, value) {
        let { costumer } = this.state;
        costumer[key] = value;
        this.setState({ costumer, edited: true });
    }

    save_changes() {
        let { costumer } = this.state;
        let { connection, toast } = this.props;
        let { name, address, password, zip, province, city } = costumer;
        connection
            .edit_costumer_info({
                name,
                address,
                province,
                city,
                password,
                zip,
            })
            .then((res) => {
                toast(
                    "بروزرسانی اطلاعات",
                    "اطلاعات کاربری شما با موفقیت بروزرسانی شد",
                    " confirm"
                );
            })
            .catch((err) => {
                if (err.response.status == 400) {
                    toast(
                        "بروزرسانی اطلاعات",
                        "اطلاعات ارسالی اشتباه است . لطفا دقت فرمایید که شماره موبایل حتما باید 11 رقم معتبر بوده و کد پستی هم باید 10 رقم باشد" +
                            err,
                        " danger"
                    );
                    return;
                }
                toast(
                    "بروزرسانی اطلاعات",
                    "خطا در بروز رسانی اطلاعات" + err,
                    " danger"
                );
            });
    }

    text_input(props) {
        let { type, value, onChange } = props;
        return (
            <input
                type={type}
                defaultValue={value === "نامشخص" ? "" : value}
                onChange={onChange}
            />
        );
    }

    select_input(props) {
        let { type, value, onChange } = props;

        let { cities, costumer } = this.state;
        let { province } = costumer;

        return (
            <select
                defaultValue={value === "نامشخص" ? "" : value}
                onChange={onChange}
                type={type}
            >
                {(type === "province"
                    ? cities.map((p) => {
                          return {
                              code: p.province_code,
                              name: p.province_name,
                          };
                      })
                    : province
                    ? cities.find((p) => {
                          return p.province_code === province;
                      }).cities
                    : []
                ).map((i) => {
                    return (
                        <option value={i.code} key={i.code + i.name}>
                            {i.name}
                        </option>
                    );
                })}
            </select>
        );
    }

    state = {
        costumer: null,
        edited: false,
        cities: null,
        countryMap: null,
    };
    render() {
        let { costumer, edited, cities } = this.state;
        let { mobile, name, province, city, address, zip } = costumer || {};

        let selected_province =
            cities &&
            cities.find((p) => {
                return p.province_code === province;
            });

        let selected_city =
            (selected_province &&
                selected_province.cities.find((c) => {
                    return c.code === city;
                })) ||
            {};

        return (
            <div className='UserInfo'>
                {costumer && costumer.signed && (
                    <Fragment>
                        <InfoElement
                            name='موبایل'
                            value={mobile}
                            on_edit={() => {}}
                            _key={"mobile"}
                            Component={this.text_input}
                            type={"tel"}
                        />
                        <InfoElement
                            name='نام و نام خانوادگی'
                            value={name}
                            on_edit={this.on_edit}
                            _key={"name"}
                            Component={this.text_input}
                            type={"name"}
                        />
                        <InfoElement
                            name='رمز عبور'
                            value='********'
                            on_edit={this.on_edit}
                            _key={"password"}
                            Component={this.text_input}
                            type={"password"}
                        />
                        <InfoElement
                            name='استان محل سکونت'
                            value={
                                selected_province &&
                                selected_province.province_name
                            }
                            on_edit={this.on_edit}
                            _key={"province"}
                            Component={this.select_input}
                            type={"province"}
                        />
                        {selected_province && selected_city && (
                            <InfoElement
                                name='شهر محل سکونت '
                                value={selected_city.name}
                                on_edit={this.on_edit}
                                _key={"city"}
                                Component={this.select_input}
                                type={"city"}
                            />
                        )}
                        <InfoElement
                            name='آدرس پستی'
                            value={address}
                            on_edit={this.on_edit}
                            _key={"address"}
                            Component={this.text_input}
                            type={"address"}
                        />
                        <InfoElement
                            name='کد پستی'
                            value={zip}
                            on_edit={this.on_edit}
                            _key={"zip"}
                            Component={this.text_input}
                            type={"zip"}
                        />
                        {edited && (
                            <div className='save_info_changes'>
                                <button
                                    className=' btn confirm'
                                    onClick={this.save_changes}
                                >
                                    ذخیره تغیرات
                                </button>
                            </div>
                        )}
                    </Fragment>
                )}
            </div>
        );
    }
}

export default UserInfo;
